import { render, staticRenderFns } from "./case_detial.vue?vue&type=template&id=1b9784e4&scoped=true"
import script from "./case_detial.vue?vue&type=script&lang=js"
export * from "./case_detial.vue?vue&type=script&lang=js"
import style0 from "./case_detial.vue?vue&type=style&index=0&id=1b9784e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9784e4",
  null
  
)

export default component.exports